import { render, staticRenderFns } from "./PaidCertificatesList.vue?vue&type=template&id=4c70d3f9"
import script from "./PaidCertificatesList.vue?vue&type=script&lang=ts"
export * from "./PaidCertificatesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports